import addCrisisCallTeamMemberAllocations from './addCrisisCallTeamMemberAllocations';
import addOrUpdateCrisisCall from './addOrUpdateCrisisCall';
import finishCrisisVisit from './finishCrisisVisit';
import removeCrisisCall from './removeCrisisCall';
import removeCrisisCallTeamMemberAllocations from './removeCrisisCallTeamMemberAllocations';
import removeCrisisCallTeamMemberAllocationsByCrisisCall from './removeCrisisCallTeamMemberAllocationsByCrisisCall';
import setCrisisAllocation from './setCrisisAllocation';
import setCrisisCalls from './setCrisisCalls';
import setCrisisCallTeamMembers from './setCrisisCallTeamMembers';
import setAllocationsFilter from './setAllocationsFilter';
import startCrisisVisit from './startCrisisVisit';
import updateCrisisCallTeamMemberAllocations from './updateCrisisCallTeamMemberAllocations';

export default {
  addCrisisCallTeamMemberAllocations,
  addOrUpdateCrisisCall,
  finishCrisisVisit,
  removeCrisisCall,
  removeCrisisCallTeamMemberAllocations,
  removeCrisisCallTeamMemberAllocationsByCrisisCall,
  setCrisisAllocation,
  setCrisisCalls,
  setCrisisCallTeamMembers,
  setAllocationsFilter,
  startCrisisVisit,
  updateCrisisCallTeamMemberAllocations,
};
